import styles from './LandingAboutUs.module.css';

const LadingContact = (props) => {
	return (
		<div className={styles.landing}>
			<h1 className='text-4xl mt-20'>Contact Us</h1>
			<p className='mt-14 text-center'>
				Hath after appear tree great fruitful green dominion moveth sixth <br />
				abundantly image that midst of god day multiply you’ll which
			</p>
		</div>
	);
};

export default LadingContact;
